// // component
// import { useSelector } from 'react-redux';
// import SvgColor from '../../../components/svg-color';

// // ----------------------------------------------------------------------

// const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;
// // const project = useSelector(store=> store.project.data)
// // console.log("this is confiq log of project", project);

// const navConfig = [
//   {
//     title: 'dashboard',
//     path: '/dashboard/app',
//     icon: icon('ic_analytics'),
//   },
//   {
//     title: 'new projects',
//     path: '/dashboard/new-project',
//     icon: icon('ic_running'),
//   },
//   {
//     title: 'running projects',
//     path: '/dashboard/running-project',
//     icon: icon('ic_running'),
//   },
//   {
//     title: 'complete projects',
//     path: '/dashboard/complete-project',
//     icon: icon('ic_running'),
//   },
//   {
//     title: 'Refund Project',
//     path: '/dashboard/refund-project',
//     icon: icon('ic_running'),
//   },
//   {
//     title: 'staff',
//     path: '/dashboard/staff',
//     icon: icon('ic_team'),
//   },

//   {
//     title: 'client',
//     path: '/dashboard/client',
//     icon: icon('ic_client'),
//   }, 
//     {
//     title: 'freelancers',
//     path: '/dashboard/Freelancers',
//     icon: icon('ic_team'),
//   },
//   {
//     title: 'Chat',
//     path: '/dashboard/projectchat',
//     icon: icon('ic_client'),
//   }, 
//   {
//     title: 'package',
//     path: '/dashboard/package',
//     icon: icon('ic_package'),
//   }, 
//   {
//     title: 'service',
//     path: '/dashboard/service',
//     icon: icon('ic_service'),
//   }, 
//   {
//     title: 'Coupon',
//     path: '/dashboard/coupon',
//     icon: icon('ic_service'),
//   }, 
//   {
//     title: 'icons-format',
//     path: '/dashboard/iconsformat',
//     icon: icon('ic_service'),
//   }, 
//   {
//     title: 'category',
//     path: '/dashboard/category',
//     icon: icon('ic_category'),
//   },
//   {
//     title: 'subcategory',
//     path: '/dashboard/subCategory',
//     icon: icon('ic_category'),
//   },
//   {
//     title: 'staff role',
//     path: '/dashboard/role',
//     icon: icon('ic_role'),
//   },
//   {
//     title: 'rating',
//     path: '/dashboard/rating',
//     icon: icon('ic_star'),
//   },
//   {
//     title: 'blog',
//     path: '/dashboard/blog',
//     icon: icon('ic_blog'),
//   },  
//   // {
//   //   title: 'login',
//   //   path: '/login',
//   //   icon: icon('ic_lock'),
//   // },
//   // {
//   //   title: 'Not found',
//   //   path: '/404',
//   //   icon: icon('ic_disabled'),
//   // },
// ];

// export default navConfig;









// // component
// import SvgColor from '../../../components/svg-color';

// // ----------------------------------------------------------------------

// const icon = (name) => (
//   <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
// );

// const navConfig = [
//   {
//     title: 'dashboard',
//     path: '/dashboard/app',
//     icon: icon('ic_analytics'),
//   },

//   // ✅ Ek "Projects" dropdown — andar 3 sub-items honge
//   {
//     title: 'Projects',
//     icon: icon('ic_running'),
//     hasDropdown: true,
//     children: [
//       {
//         title: 'New Projects',
//         path: '/dashboard/new-project',
//       },
//       {
//         title: 'Running Projects',
//         path: '/dashboard/running-project',
//       },
//       {
//         title: 'Complete Projects',
//         path: '/dashboard/complete-project',
//       },
//       {
//         title: 'Refund Project',
//         path: '/dashboard/refund-project',
//       },
//     ],
//   },

//   {
//     title: 'staff',
//     path: '/dashboard/staff',
//     icon: icon('ic_team'),
//   },
//   {
//     title: 'client',
//     path: '/dashboard/client',
//     icon: icon('ic_client'),
//   },
//   {
//     title: 'freelancers',
//     path: '/dashboard/Freelancers',
//     icon: icon('ic_team'),
//   },
//   {
//     title: 'Chat',
//     path: '/dashboard/projectchat',
//     icon: icon('ic_client'),
//   },
//   {
//     title: 'package',
//     path: '/dashboard/package',
//     icon: icon('ic_package'),
//   },
//   {
//     title: 'service',
//     path: '/dashboard/service',
//     icon: icon('ic_service'),
//   },
//   {
//     title: 'Coupon',
//     path: '/dashboard/coupon',
//     icon: icon('ic_service'),
//   },
//   {
//     title: 'icons-format',
//     path: '/dashboard/iconsformat',
//     icon: icon('ic_service'),
//   },
//   {
//     title: 'category',
//     path: '/dashboard/category',
//     icon: icon('ic_category'),
//   },
//   {
//     title: 'subcategory',
//     path: '/dashboard/subCategory',
//     icon: icon('ic_category'),
//   },
//   {
//     title: 'staff role',
//     path: '/dashboard/role',
//     icon: icon('ic_role'),
//   },
//   {
//     title: 'rating',
//     path: '/dashboard/rating',
//     icon: icon('ic_star'),
//   },
//   {
//     title: 'blog',
//     path: '/dashboard/blog',
//     icon: icon('ic_blog'),
//   },
// ];

// export default navConfig;










// import DashboardIcon from '@mui/icons-material/Dashboard';
// import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
// import FiberNewIcon from '@mui/icons-material/FiberNew';
// import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
// import BadgeIcon from '@mui/icons-material/Badge';
// import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
// import HandymanIcon from '@mui/icons-material/Handyman';
// import ChatIcon from '@mui/icons-material/Chat';
// import Inventory2Icon from '@mui/icons-material/Inventory2';
// import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
// import LocalOfferIcon from '@mui/icons-material/LocalOffer';
// import FormatShapesIcon from '@mui/icons-material/FormatShapes';
// import CategoryIcon from '@mui/icons-material/Category';
// import AccountTreeIcon from '@mui/icons-material/AccountTree';
// import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
// import StarRateIcon from '@mui/icons-material/StarRate';
// import ArticleIcon from '@mui/icons-material/Article';

// // ----------------------------------------------------------------------

// const navConfig = [
//   {
//     title: 'dashboard',
//     path: '/dashboard/app',
//     icon: <DashboardIcon />,
//   },

//   // ✅ Projects dropdown
//   {
//     title: 'Order Detail',
//     icon: <FolderSpecialIcon />,
//     hasDropdown: true,
//     children: [
//       {
//         title: 'New Projects',
//         path: '/dashboard/new-project',
//         icon: <FiberNewIcon sx={{ width: 18, height: 18 }} />,
//       },
//       {
//         title: 'Running Projects',
//         path: '/dashboard/running-project',
//         icon: <DirectionsRunIcon sx={{ width: 18, height: 18 }} />,
//       },
//       {
//         title: 'Complete Projects',
//         path: '/dashboard/complete-project',
//         icon: <CheckCircleIcon sx={{ width: 18, height: 18 }} />,
//       },
//       {
//         title: 'Refund Project',
//         path: '/dashboard/refund-project',
//         icon: <CurrencyExchangeIcon sx={{ width: 18, height: 18 }} />,
//       },
//     ],
//   },
//   {
//     title: 'Team',
//     icon: <FolderSpecialIcon />,
//     hasDropdown: true,
//     children: [
//   {
//     title: 'staff',
//     path: '/dashboard/staff',
//     icon: <BadgeIcon />,
//   },
//     {
//     title: 'freelancers',
//     path: '/dashboard/Freelancers',
//     icon: <HandymanIcon />,
//   },
 
//     ],
//   },




//   {
//     title: 'Services',
//     icon: <FolderSpecialIcon />,
//     hasDropdown: true,
//     children: [

//           {
//     title: 'category',
//     path: '/dashboard/category',
//     icon: <CategoryIcon />,
//   },
//   {
//     title: 'subcategory',
//     path: '/dashboard/subCategory',
//     icon: <AccountTreeIcon />,
//   },
//   {
//     title: 'package',
//     path: '/dashboard/package',
//     icon: <Inventory2Icon />,
//   },
//   {
//     title: 'Project',
//     path: '/dashboard/service',
//     icon: <MiscellaneousServicesIcon />,
//   }
 

//     ],
//   },







//   {
//     title: 'client',
//     path: '/dashboard/client',
//     icon: <PeopleAltIcon />,
//   },

//   {
//     title: 'Chat',
//     path: '/dashboard/projectchat',
//     icon: <ChatIcon />,
//   },

//   {
//     title: 'Coupon',
//     path: '/dashboard/coupon',
//     icon: <LocalOfferIcon />,
//   },
//   {
//     title: 'icons-format',
//     path: '/dashboard/iconsformat',
//     icon: <FormatShapesIcon />,
//   },

//   {
//     title: 'staff role',
//     path: '/dashboard/role',
//     icon: <AdminPanelSettingsIcon />,
//   },
//   {
//     title: 'rating',
//     path: '/dashboard/rating',
//     icon: <StarRateIcon />,
//   },
//   {
//     title: 'blog',
//     path: '/dashboard/blog',
//     icon: <ArticleIcon />,
//   },

//    {
//     title: 'HelpSupport',
//     path: '/dashboard/Help-Support',
//     icon: <MiscellaneousServicesIcon />,
//   }
// ];

// export default navConfig;
















import DashboardIcon from '@mui/icons-material/Dashboard';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import BadgeIcon from '@mui/icons-material/Badge';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import HandymanIcon from '@mui/icons-material/Handyman';
import ChatIcon from '@mui/icons-material/Chat';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CategoryIcon from '@mui/icons-material/Category';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import StarRateIcon from '@mui/icons-material/StarRate';
import ArticleIcon from '@mui/icons-material/Article';
import AssignmentIcon from '@mui/icons-material/Assignment';        // Order Detail
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'; // New Projects
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'; // Running Projects
import TaskAltIcon from '@mui/icons-material/TaskAlt';              // Complete Projects
import MoneyOffIcon from '@mui/icons-material/MoneyOff';            // Refund Project
import GroupsIcon from '@mui/icons-material/Groups';                // Team
import DesignServicesIcon from '@mui/icons-material/DesignServices'; // Services
import BuildIcon from '@mui/icons-material/Build';                  // Package / Project
import PaletteIcon from '@mui/icons-material/Palette';              // icons-format
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';        // HelpSupport

// ----------------------------------------------------------------------

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: <DashboardIcon />,
  },

  // ✅ Order Detail dropdown
  {
    title: 'Order Detail',
    icon: <AssignmentIcon />,           // 📋 Order/assignment feel
    hasDropdown: true,
    children: [
      {
        title: 'New Projects',
        path: '/dashboard/new-project',
        icon: <AddCircleOutlineIcon sx={{ width: 18, height: 18 }} />,   // ➕ Naya project
      },
      {
        title: 'Running Projects',
        path: '/dashboard/running-project',
        icon: <PlayCircleOutlineIcon sx={{ width: 18, height: 18 }} />,  // ▶️ Chal raha hai
      },
      {
        title: 'Complete Projects',
        path: '/dashboard/complete-project',
        icon: <TaskAltIcon sx={{ width: 18, height: 18 }} />,            // ✅ Mukammal
      },
      {
        title: 'Refund Project',
        path: '/dashboard/refund-project',
        icon: <MoneyOffIcon sx={{ width: 18, height: 18 }} />,           // 💸 Refund
      },
    ],
  },

  // ✅ Team dropdown
  {
    title: 'Team',
    icon: <GroupsIcon />,               // 👥 Team/group
    hasDropdown: true,
    children: [
      {
        title: 'staff',
        path: '/dashboard/staff',
        icon: <BadgeIcon />,            // 🪪 Staff badge
      },
      {
        title: 'freelancers',
        path: '/dashboard/Freelancers',
        icon: <HandymanIcon />,         // 🔧 Kaam karne wala
      },
    ],
  },

  // ✅ Services dropdown
  {
    title: 'Services',
    icon: <DesignServicesIcon />,       // 🎨 Services
    hasDropdown: true,
    children: [
      {
        title: 'category',
        path: '/dashboard/category',
        icon: <CategoryIcon />,         // 🗂️ Category
      },
      {
        title: 'subcategory',
        path: '/dashboard/subCategory',
        icon: <AccountTreeIcon />,      // 🌲 Sub-tree structure
      },
      {
        title: 'package',
        path: '/dashboard/package',
        icon: <Inventory2Icon />,       // 📦 Package/box
      },
      {
        title: 'Project',
        path: '/dashboard/service',
        icon: <BuildIcon />,            // 🔨 Project build karna
      },
      {
        title: 'combo services',
        path: '/dashboard/ComboServices',
        icon: <BuildIcon />,            // 🔨 Project build karna
      },
    ],
  },

  {
    title: 'client',
    path: '/dashboard/client',
    icon: <PeopleAltIcon />,            // 👤 Clients/people
  },
  {
    title: 'Chat',
    path: '/dashboard/projectchat',
    icon: <ChatIcon />,                 // 💬 Chat
  },
  {
    title: 'Coupon',
    path: '/dashboard/coupon',
    icon: <LocalOfferIcon />,           // 🏷️ Coupon/tag
  },
  // {
  //   title: 'icons-format',
  //   path: '/dashboard/iconsformat',
  //   icon: <PaletteIcon />,              // 🎨 Format/design
  // },


// icons format start

 {
    title: 'icons format',
    icon: <DesignServicesIcon />,       // 🎨 Services
    hasDropdown: true,
    children: [
      {
    title: 'icons-format',
    path: '/dashboard/iconsformat',
    icon: <PaletteIcon />,              // 🎨 Format/design
  },

      {
        title: 'bulk-email-images',
        path: '/dashboard/EmailBuilderImages',
        icon: <AccountTreeIcon />,      // 🌲 Sub-tree structure
      },

    ],
  },
// icons format end 



  {
    title: 'staff role',
    path: '/dashboard/role',
    icon: <AdminPanelSettingsIcon />,   // 🛡️ Admin/role settings
  },
  {
    title: 'rating',
    path: '/dashboard/rating',
    icon: <StarRateIcon />,             // ⭐ Rating
  },
  {
    title: 'blog',
    path: '/dashboard/blog',
    icon: <ArticleIcon />,              // 📰 Blog/article
  },
  
  {
    title: 'HelpSupport',
    path: '/dashboard/Help-Support',
    icon: <HeadsetMicIcon />,           // 🎧 Help & Support
  },
  {
    title: 'Staffhelpsupport',
    path: '/dashboard/Staffhelpsupport',
    icon: <HeadsetMicIcon />,           // 🎧 Help & Support
  },

  {
    title: 'Bulk-Mailing',
    path: '/dashboard/BulkMailing',
    icon: <HeadsetMicIcon />,           // 🎧 Help & Support
  },


// management 

  {
    title: 'Mangament Settings',
    icon: <GroupsIcon />,               // 👥 Team/group
    hasDropdown: true,
    children: [
      {
        title: 'Add staff',
        path: '/dashboard/Add-Management',
        icon: <BadgeIcon />,            // 🪪 Staff badge
      },
      {
        title: 'Permissions',
        path: '/dashboard/Permissions',
        icon: <HandymanIcon />,         // 🔧 Kaam karne wala
      },
    ],
  },



];

export default navConfig;